import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CollegeStaff from "./Icons/CollegeStaff";
import HighSchool from "./Icons/HighSchool";
import NonTeachingStaff from "./Icons/NonTeachingStaff";
import PostalStaff from "./Icons/PostalStaff";
import PrimarySchool from "./Icons/PrimarySchool";
import RailwayStaff from "./Icons/RailwayStaff";

var getImgComponent = function getImgComponent(_ref) {
  var img = _ref.img,
      height = _ref.height,
      width = _ref.width;

  switch (img) {
    case "COLLAGE_STAFF":
      return /*#__PURE__*/_jsx(CollegeStaff, {
        height: height,
        width: width
      });

    case "NON_TEACHING_STAFF":
      return /*#__PURE__*/_jsx(NonTeachingStaff, {
        height: height,
        width: width
      });

    case "POSTAL_STAFF":
      return /*#__PURE__*/_jsx(PostalStaff, {
        height: height,
        width: width
      });

    case "PRIMARY_SCHOOL":
      return /*#__PURE__*/_jsx(PrimarySchool, {
        height: height,
        width: width
      });

    case "RAILWAY_STAFF":
      return /*#__PURE__*/_jsx(RailwayStaff, {
        height: height,
        width: width
      });

    case "HIGH_SCHOOL":
    default:
      return /*#__PURE__*/_jsx(HighSchool, {
        height: height,
        width: width
      });
  }
};

export default function CategoryIcons(_ref2) {
  var img = _ref2.img,
      height = _ref2.height,
      width = _ref2.width;
  return getImgComponent({
    img: img,
    height: height,
    width: width
  });
}